





























































import { Component, Vue } from "vue-property-decorator";
import { Login } from "@/api";
import { Action, Getter } from "vuex-class";
import { IWhoAmI, Callback } from "@/interfaces";
import { USERNAME_RULES, PASSWORD_RULES } from "@/validators";
import { UserInterface } from "@/utils/UserInterface";

@Component({})
export default class LoginComponent extends Vue {
  public user = "";
  public password = "";
  public loading = false;
  public valid = false;
  public showLogin = true;
  public userNameRules = USERNAME_RULES;
  public passRules = PASSWORD_RULES;
  public showPass: boolean = false;

  private UI__: UserInterface;

  @Action("load", { namespace: "AppModule" })
  public loadAction!: Callback;

  @Getter("user", { namespace: "AppModule" })
  public userLogged!: IWhoAmI | null;

  // @Action("setSnackbar", { namespace: "AppModule" })
  // public setSnackbarAction!: Callback;

  @Action("setToken", { namespace: "AppModule" })
  public setTokenAction!: Callback;

  mounted() {
    this.UI__ = new UserInterface(this);
  }

  public TryMoveTo(ix: number, evt: any): void {
    // console.log(ix, evt)
  }

  async validate() {
    if (!(this.$refs.loginForm as HTMLFormElement).validate()) return;

    this.loading = true;
    this.showPass = false;

    this.UI__.TurnBlockerOn();
    const resp = await Login({
      user: this.user,
      pass: this.password,
    });

    if (!resp.Ok) {
      this.loading = false;
      this.UI__.TurnBlockerOff();
      this.UI__.SnacError(resp.Msg);
      return;
    }

    this.setTokenAction(resp.Token);

    await this.loadAction();

    this.UI__.TurnBlockerOff();
    this.loading = false;
    this.showLogin = false;

    this.UI__.SnacSuccess("User logged in successfully !");

    setTimeout(() => {
      this.$router.push("/dashboard");
    }, 2000);
  }

  goToForgotPass() {
    this.$router.push("/forgot-password");
  }

  get welcomeMessage() {
    return this.userLogged
      ? `Welcome ${this.userLogged.FName} ${this.userLogged.LName}`
      : "";
  }
}
